// pages/LineasContrato.js
import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Card,
  InputNumber,
  DatePicker,
  Divider,
  Collapse,
  Descriptions,
  Tabs,
  Radio,
  Checkbox
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  ReloadOutlined,
  EyeOutlined,
  CalendarOutlined,
  EuroOutlined,
  FileTextOutlined,
  DollarOutlined,
  CopyOutlined,
  FilterOutlined,
  SaveOutlined,
  CloseOutlined,
  ArrowLeftOutlined,
  ImportOutlined,
  ExportOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from '../utils/dayjsConfig';
import { useNavigate, useParams } from 'react-router-dom';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;
const { TabPane } = Tabs;

const LineasContrato = () => {
  const navigate = useNavigate();
  const { codigoContrato } = useParams();
  
  // Estados principales
  const [loading, setLoading] = useState(false);
  const [contrato, setContrato] = useState(null);
  const [lineas, setLineas] = useState([]);
  const [filtroLineas, setFiltroLineas] = useState([]);

  const [guardandoTemporada, setGuardandoTemporada] = useState(false);
const [guardandoLinea, setGuardandoLinea] = useState(false);
  
  // Estados para temporadas
  const [temporadas, setTemporadas] = useState([]);
  const [temporadasFiltradas, setTemporadasFiltradas] = useState([]);
  const [activeTab, setActiveTab] = useState('temporadas');
  
  // Estados para modal y formulario de temporada
  const [modalTemporadaVisible, setModalTemporadaVisible] = useState(false);
  const [modalTemporadaType, setModalTemporadaType] = useState('create');
  const [currentTemporada, setCurrentTemporada] = useState(null);
  const [formTemporada] = Form.useForm();
  
  // Estados para modal y formulario de línea individual
  const [modalLineaVisible, setModalLineaVisible] = useState(false);
  const [modalLineaType, setModalLineaType] = useState('create');
  const [currentLinea, setCurrentLinea] = useState(null);
  const [formLinea] = Form.useForm();
  
  // Estados para filtros
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const [showWeekend, setShowWeekend] = useState(false);
  
  // Estados para datos en edición
  const [preciosBase, setPreciosBase] = useState({
    preciopc: 0,
    preciomp: 0,
    preciohd: 0,
    precioha: 0,
    PrecioIn: 0,
    preciodo: 0,
    precioti: 0
  });
  
  const [suplementos, setSuplementos] = useState({
    precioa1: 0,
    precioa2: 0,
    precioade: 0,
    CheckPrecinInPorcentaje: false
  });
  
  const [descuentos, setDescuentos] = useState({
    preciode1: 0,
    precioha1: 0,
    precion11: 0,
    precion12: 0,
    preciode2: 0,
    precioha2: 0,
    precion21: 0,
    precion22: 0,
    preciode3: 0,
    precioha3: 0,
    precion31: 0,
    precion32: 0
  });
  
  const [otros, setOtros] = useState({
    DobleUsoIndividual: 0,
    MinNoches: 0,
    SuplCortEstanc: 0,
    SuplCortEstancP: 0,
    DUISuplemento: false,
    DUIPorcentaje: false,
    esweekend: false,
    PrecioINPorcentaje: false
  });

  // Columnas para la tabla de días individuales
  const columnsDias = [
    {
      title: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 120,
      sorter: (a, b) => new Date(a.fecha) - new Date(b.fecha),
      render: (fecha) => dayjs(fecha).format('DD/MM/YYYY'),
    },
    {
      title: 'Día',
      key: 'dia',
      width: 100,
      render: (_, record) => {
        const fecha = dayjs(record.fecha);
        const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
        return dias[fecha.day()];
      },
    },
    {
      title: 'MP',
      dataIndex: 'preciomp',
      key: 'preciomp',
      width: 100,
      render: (precio) => (
        <Text strong style={{ color: '#1890ff' }}>
          {precio.toFixed(2)} €
        </Text>
      ),
    },
    {
      title: 'HD',
      dataIndex: 'preciohd',
      key: 'preciohd',
      width: 100,
      render: (precio) => precio.toFixed(2),
    },
    {
      title: 'IN',
      dataIndex: 'PrecioIn',
      key: 'PrecioIn',
      width: 100,
      render: (precio) => precio > 0 ? precio.toFixed(2) : '-',
    },
    {
      title: 'DUI',
      dataIndex: 'DobleUsoIndividual',
      key: 'DobleUsoIndividual',
      width: 100,
      render: (dui) => dui > 0 ? dui.toFixed(2) : '-',
    },
    {
      title: 'Niño 1',
      dataIndex: 'precion11',
      key: 'precion11',
      width: 100,
      render: (precio) => precio > 0 ? precio.toFixed(2) : '-',
    },
    {
      title: 'WE',
      dataIndex: 'esweekend',
      key: 'esweekend',
      width: 80,
      render: (weekend) => (
        weekend ? (
          <Tag color="purple">Sí</Tag>
        ) : (
          <Tag color="default">No</Tag>
        )
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="small"
              onClick={() => handleEditLinea(record)}
            />
          </Tooltip>
          <Tooltip title="Duplicar">
            <Button
              type="default"
              icon={<CopyOutlined />}
              size="small"
              onClick={() => handleDuplicateLinea(record)}
            />
          </Tooltip>
          <Popconfirm
            title="¿Eliminar línea?"
            onConfirm={() => handleDeleteLinea(record.fecha)}
            okText="Sí"
            cancelText="No"
          >
            <Button
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Columnas para la tabla de temporadas
  const columnsTemporadas = [
    {
      title: 'Temporada',
      key: 'rango',
      width: 250,
      render: (_, record) => (
        <div>
          <div>
            <Text strong>Desde: </Text>
            {dayjs(record.fechaDesde).format('DD/MM/YYYY')}
          </div>
          <div>
            <Text strong>Hasta: </Text>
            {dayjs(record.fechaHasta).format('DD/MM/YYYY')}
          </div>
          <div>
            <Tag color="blue">{record.dias} días</Tag>
            {record.esweekend && <Tag color="purple" style={{ marginLeft: 4 }}>WE</Tag>}
          </div>
        </div>
      ),
    },
    {
      title: 'Precios Principales',
      key: 'precios',
      width: 300,
      render: (_, record) => (
        <div>
          <div>
            <Text strong>MP: </Text>
            <Text style={{ color: '#1890ff' }}>{record.precios.preciomp.toFixed(2)} €</Text>
          </div>
          <div>
            <Text strong>HD: </Text>
            {record.precios.preciohd.toFixed(2)} €
          </div>
          <div>
            <Text strong>IN: </Text>
            {record.precios.PrecioIn > 0 ? `${record.precios.PrecioIn.toFixed(2)} €` : '-'}
          </div>
          <div>
            <Text strong>Niño 1: </Text>
            {record.precios.precion11 > 0 ? `${record.precios.precion11.toFixed(2)} €` : '-'}
          </div>
        </div>
      ),
    },
    {
      title: 'Configuración',
      key: 'config',
      width: 200,
      render: (_, record) => (
        <div>
          <div>
            <Text strong>DUI: </Text>
            {record.precios.DobleUsoIndividual > 0 ? 
                `${record.precios.DobleUsoIndividual.toFixed(2)} €` : '-'}
          </div>
          <div>
            <Text strong>Mín. Noches: </Text>
            {record.precios.MinNoches > 0 ? record.precios.MinNoches : '-'}
          </div>
          <div>
            <Text strong>IN %: </Text>
            {record.precios.PrecioINPorcentaje ? <Tag color="orange">Sí</Tag> : <Tag>No</Tag>}
          </div>
        </div>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 150,
      render: (_, record) => (
        <Space>
          <Tooltip title="Editar Temporada">
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="small"
              onClick={() => handleEditarTemporada(record)}
            />
          </Tooltip>
          <Tooltip title="Duplicar Temporada">
            <Button
              type="default"
              icon={<CopyOutlined />}
              size="small"
              onClick={() => handleDuplicarTemporada(record)}
            />
          </Tooltip>
          <Tooltip title="Eliminar Temporada">
            <Popconfirm
              title="¿Eliminar esta temporada?"
              description="Se eliminarán todas las líneas de esta temporada"
              onConfirm={() => handleEliminarTemporada(record)}
              okText="Sí"
              cancelText="No"
            >
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Efectos iniciales
  useEffect(() => {
    if (codigoContrato) {
      fetchContrato();
      fetchLineas();
    }
  }, [codigoContrato]);

  useEffect(() => {
    aplicarFiltros();
  }, [lineas, fechaDesde, fechaHasta, showWeekend]);

  useEffect(() => {
    if (lineas.length > 0) {
      const temporadasAgrupadas = agruparPorTemporadas(lineas);
      setTemporadas(temporadasAgrupadas);
      aplicarFiltrosTemporadas(temporadasAgrupadas);
    } else {
      setTemporadas([]);
      setTemporadasFiltradas([]);
    }
  }, [lineas]);

  // Funciones principales
  const fetchContrato = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/contratos/${codigoContrato}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContrato(response.data.data);
    } catch (error) {
      console.error('❌ Error cargando contrato:', error);
      message.error('Error al cargar el contrato');
    }
  };

const fetchLineas = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${BASE_URL}/api/lineascontrato/${codigoContrato}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        pageSize: 1000
      }
    });
    setLineas(response.data.data || []);
  } catch (error) {
    console.error('❌ Error cargando líneas:', error);
    message.error('Error al cargar las líneas del contrato');
    setLineas([]);
  } finally {
    setLoading(false);
  }
};

  // Función para agrupar por temporadas
  const agruparPorTemporadas = (lineas) => {
    if (!lineas || lineas.length === 0) return [];
    
    const temporadas = [];
    let temporadaActual = null;
    
    // Ordenar las líneas por fecha
    const lineasOrdenadas = [...lineas].sort((a, b) => 
      new Date(a.fecha) - new Date(b.fecha)
    );
    
    lineasOrdenadas.forEach((linea, index) => {
      const fechaActual = dayjs(linea.fecha);
      
      // Si es la primera línea o los precios son diferentes
      if (!temporadaActual || !sonPreciosIguales(temporadaActual.precios, linea)) {
        // Si hay una temporada anterior, la cerramos
        if (temporadaActual) {
          temporadaActual.fechaHasta = lineasOrdenadas[index - 1].fecha;
          temporadas.push(temporadaActual);
        }
        
        // Creamos nueva temporada
        temporadaActual = {
          id: `temp_${temporadas.length + 1}`,
          fechaDesde: linea.fecha,
          fechaHasta: linea.fecha,
          precios: extraerPrecios(linea),
          dias: 1,
          lineas: [linea],
          esweekend: linea.esweekend
        };
      } else {
        // Misma temporada, extender rango
        temporadaActual.fechaHasta = linea.fecha;
        temporadaActual.dias++;
        temporadaActual.lineas.push(linea);
      }
      
      // Si es la última línea, agregamos la temporada actual
      if (index === lineasOrdenadas.length - 1) {
        temporadas.push(temporadaActual);
      }
    });
    
    return temporadas;
  };

  // Función para comparar si los precios son iguales
  const sonPreciosIguales = (precios1, linea2) => {
    const precios2 = extraerPrecios(linea2);
    
    // Comparar solo los campos principales para agrupación
    return (
      precios1.preciomp === precios2.preciomp &&
      precios1.preciohd === precios2.preciohd &&
      precios1.PrecioIn === precios2.PrecioIn &&
      precios1.DobleUsoIndividual === precios2.DobleUsoIndividual &&
      precios1.MinNoches === precios2.MinNoches &&
      precios1.esweekend === precios2.esweekend &&
      precios1.precion11 === precios2.precion11 &&
      precios1.PrecioINPorcentaje === precios2.PrecioINPorcentaje
    );
  };

  // Función para extraer todos los precios de una línea
  const extraerPrecios = (linea) => {
    return {
      preciopc: linea.preciopc || 0,
      preciomp: linea.preciomp || 0,
      preciohd: linea.preciohd || 0,
      precioha: linea.precioha || 0,
      PrecioIn: linea.PrecioIn || 0,
      preciodo: linea.preciodo || 0,
      precioti: linea.precioti || 0,
      precioa1: linea.precioa1 || 0,
      precioa2: linea.precioa2 || 0,
      precioade: linea.precioade || 0,
      preciode1: linea.preciode1 || 0,
      precioha1: linea.precioha1 || 0,
      precion11: linea.precion11 || 0,
      precion12: linea.precion12 || 0,
      preciode2: linea.preciode2 || 0,
      precioha2: linea.precioha2 || 0,
      precion21: linea.precion21 || 0,
      precion22: linea.precion22 || 0,
      preciode3: linea.preciode3 || 0,
      precioha3: linea.PrecioHA3 || 0,
      precion31: linea.precion31 || 0,
      precion32: linea.precion32 || 0,
      DobleUsoIndividual: linea.DobleUsoIndividual || 0,
      MinNoches: linea.MinNoches || 0,
      SuplCortEstanc: linea.SuplCortEstanc || 0,
      SuplCortEstancP: linea.SuplCortEstancP || 0,
      DUISuplemento: linea.DUISuplemento || false,
      DUIPorcentaje: linea.DUIPorcentaje || false,
      PrecioINPorcentaje: linea.PrecioINPorcentaje || false,
      esweekend: linea.esweekend || false
    };
  };

  const aplicarFiltros = () => {
    let filtered = [...lineas];
    
    if (fechaDesde) {
      filtered = filtered.filter(linea => 
        dayjs(linea.fecha).isSameOrAfter(fechaDesde, 'day')
      );
    }
    
    if (fechaHasta) {
      filtered = filtered.filter(linea => 
        dayjs(linea.fecha).isSameOrBefore(fechaHasta, 'day')
      );
    }
    
    if (showWeekend) {
      filtered = filtered.filter(linea => linea.esweekend);
    }
    
    setFiltroLineas(filtered);
  };

  const aplicarFiltrosTemporadas = (tempList = temporadas) => {
    let filtered = [...tempList];
    
    if (fechaDesde) {
      filtered = filtered.filter(temp => 
        dayjs(temp.fechaHasta).isSameOrAfter(fechaDesde, 'day')
      );
    }
    
    if (fechaHasta) {
      filtered = filtered.filter(temp => 
        dayjs(temp.fechaDesde).isSameOrBefore(fechaHasta, 'day')
      );
    }
    
    if (showWeekend) {
      filtered = filtered.filter(temp => temp.esweekend);
    }
    
    setTemporadasFiltradas(filtered);
  };

  const handleResetFiltros = () => {
    setFechaDesde(null);
    setFechaHasta(null);
    setShowWeekend(false);
    aplicarFiltros();
    aplicarFiltrosTemporadas();
  };

  // ========== FUNCIONES PARA TEMPORADAS ==========

  const handleCrearTemporada = () => {
    setModalTemporadaType('create');
    setCurrentTemporada(null);
    formTemporada.resetFields();
    
    // Resetear todos los estados
    setPreciosBase({
      preciopc: 0,
      preciomp: 0,
      preciohd: 0,
      precioha: 0,
      PrecioIn: 0,
      preciodo: 0,
      precioti: 0
    });
    
    setSuplementos({
      precioa1: 0,
      precioa2: 0,
      precioade: 0,
      CheckPrecinInPorcentaje: false
    });
    
    setDescuentos({
      preciode1: 0,
      precioha1: 0,
      precion11: 0,
      precion12: 0,
      preciode2: 0,
      precioha2: 0,
      precion21: 0,
      precion22: 0,
      preciode3: 0,
      precioha3: 0,
      precion31: 0,
      precion32: 0
    });
    
    setOtros({
      DobleUsoIndividual: 0,
      MinNoches: 0,
      SuplCortEstanc: 0,
      SuplCortEstancP: 0,
      DUISuplemento: false,
      DUIPorcentaje: false,
      esweekend: false,
      PrecioINPorcentaje: false
    });
    
    // Valores por defecto en el formulario
    const hoy = dayjs();
    formTemporada.setFieldsValue({
      fechaDesde: hoy,
      fechaHasta: hoy,
      preciomp: 0,
      preciohd: 0,
      PrecioIn: 0,
      esweekend: false
    });
    
    setModalTemporadaVisible(true);
  };

  const handleEditarTemporada = (temporada) => {
    setModalTemporadaType('edit');
    setCurrentTemporada(temporada);
    
    // Cargar datos en los estados
    const precios = temporada.precios;
    setPreciosBase({
      preciopc: precios.preciopc || 0,
      preciomp: precios.preciomp || 0,
      preciohd: precios.preciohd || 0,
      precioha: precios.precioha || 0,
      PrecioIn: precios.PrecioIn || 0,
      preciodo: precios.preciodo || 0,
      precioti: precios.precioti || 0
    });
    
    setSuplementos({
      precioa1: precios.precioa1 || 0,
      precioa2: precios.precioa2 || 0,
      precioade: precios.precioade || 0,
      CheckPrecinInPorcentaje: precios.PrecioINPorcentaje || false
    });
    
    setDescuentos({
      preciode1: precios.preciode1 || 0,
      precioha1: precios.precioha1 || 0,
      precion11: precios.precion11 || 0,
      precion12: precios.precion12 || 0,
      preciode2: precios.preciode2 || 0,
      precioha2: precios.precioha2 || 0,
      precion21: precios.precion21 || 0,
      precion22: precios.precion22 || 0,
      preciode3: precios.preciode3 || 0,
      precioha3: precios.precioha3 || 0,
      precion31: precios.precion31 || 0,
      precion32: precios.precion32 || 0
    });
    
    setOtros({
      DobleUsoIndividual: precios.DobleUsoIndividual || 0,
      MinNoches: precios.MinNoches || 0,
      SuplCortEstanc: precios.SuplCortEstanc || 0,
      SuplCortEstancP: precios.SuplCortEstancP || 0,
      DUISuplemento: precios.DUISuplemento || false,
      DUIPorcentaje: precios.DUIPorcentaje || false,
      esweekend: precios.esweekend || false,
      PrecioINPorcentaje: precios.PrecioINPorcentaje || false
    });
    
    // Cargar datos en el formulario
    formTemporada.setFieldsValue({
      fechaDesde: dayjs(temporada.fechaDesde),
      fechaHasta: dayjs(temporada.fechaHasta),
      preciomp: precios.preciomp,
      preciohd: precios.preciohd,
      PrecioIn: precios.PrecioIn,
      esweekend: precios.esweekend,
      DobleUsoIndividual: precios.DobleUsoIndividual,
      MinNoches: precios.MinNoches,
      PrecioINPorcentaje: precios.PrecioINPorcentaje
    });
    
    setModalTemporadaVisible(true);
  };

// pages/LineasContrato.js - Versión simplificada y correcta de handleGuardarTemporada
const handleGuardarTemporada = async () => {
  try {
    const values = await formTemporada.validateFields();
    const token = localStorage.getItem('token');
    
    const nuevaFechaDesde = values.fechaDesde;
    const nuevaFechaHasta = values.fechaHasta;
    
    // Validar rango de fechas
    if (nuevaFechaDesde.isAfter(nuevaFechaHasta)) {
      message.error('La fecha desde debe ser anterior a la fecha hasta');
      return;
    }
    
    const nuevaFechaDesdeStr = nuevaFechaDesde.format('YYYY-MM-DD');
    const nuevaFechaHastaStr = nuevaFechaHasta.format('YYYY-MM-DD');
    
    // Activar indicador de carga
    setGuardandoTemporada(true);
    
    // Datos para actualizar
    const datosActualizacion = {
      codigo: codigoContrato,
      fechaDesde: nuevaFechaDesdeStr,
      fechaHasta: nuevaFechaHastaStr,
      preciomp: preciosBase.preciomp,
      preciohd: preciosBase.preciohd,
      PrecioIn: preciosBase.PrecioIn,
      esweekend: otros.esweekend,
      DobleUsoIndividual: otros.DobleUsoIndividual,
      MinNoches: otros.MinNoches,
      modo: 'actualizar'
    };
    
    let response;
    
    // Mostrar mensaje de progreso
    const hideMessage = message.loading({
      content: modalTemporadaType === 'create' 
        ? 'Creando temporada...' 
        : 'Actualizando temporada...',
      duration: 0,
      key: 'savingTemporada'
    });
    
    try {
      if (modalTemporadaType === 'create') {
        // Crear nueva temporada
        response = await axios.post(`${BASE_URL}/api/lineascontrato/rango`, datosActualizacion, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.success) {
          message.success({
            content: 'Temporada creada correctamente',
            key: 'savingTemporada',
            duration: 3
          });
          
          // Mostrar resumen de lo creado
          if (response.data.data) {
            const { nuevas, actualizadas, sinCambios } = response.data.data;
            let detalles = [];
            if (nuevas > 0) detalles.push(`${nuevas} nuevos días`);
            if (actualizadas > 0) detalles.push(`${actualizadas} días actualizados`);
            if (sinCambios > 0) detalles.push(`${sinCambios} días sin cambios`);
            
            // if (detalles.length > 0) {
            //   message.info({
            //     content: `Detalles: ${detalles.join(', ')}`,
            //     duration: 4
            //   });
            // }
          }
          
          setModalTemporadaVisible(false);
          fetchLineas();
        }
        
      } else {
        // ====== EDICIÓN DE TEMPORADA ======
        // Solo actualizamos el nuevo rango especificado
        response = await axios.post(`${BASE_URL}/api/lineascontrato/rango`, datosActualizacion, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.success) {
          message.success({
            content: 'Temporada actualizada correctamente',
            key: 'savingTemporada',
            duration: 3
          });
          
          // Mostrar mensaje informativo sobre lo que quedó sin cambios
          const fechaOriginalDesde = dayjs(currentTemporada.fechaDesde);
          const fechaOriginalHasta = dayjs(currentTemporada.fechaHasta);
          
          if (nuevaFechaHasta.isBefore(fechaOriginalHasta)) {
            const diasMantenidos = fechaOriginalHasta.diff(nuevaFechaHasta, 'day');
            if (diasMantenidos > 0) {
              message.info({
                content: `${diasMantenidos} días después del rango editado mantienen sus valores originales`,
                duration: 4
              });
            }
          }
          
          // Mostrar resumen de cambios
          if (response.data.data) {
            const { nuevas, actualizadas, sinCambios } = response.data.data;
            let detalles = [];
            if (nuevas > 0) detalles.push(`${nuevas} nuevos días`);
            if (actualizadas > 0) detalles.push(`${actualizadas} días actualizados`);
            if (sinCambios > 0) detalles.push(`${sinCambios} días sin cambios`);
            
            if (detalles.length > 0) {
              message.info({
                content: `Detalles: ${detalles.join(', ')}`,
                duration: 4
              });
            }
          }
          
          setModalTemporadaVisible(false);
          fetchLineas();
        }
      }
      
    } finally {
      // Limpiar mensaje de carga
      hideMessage();
      setGuardandoTemporada(false);
    }
    
  } catch (error) {
    console.error('❌ Error guardando temporada:', error);
    
    // Mostrar error específico
    const errorMsg = error.response?.data?.error || 'Error al guardar la temporada';
    message.error({
      content: errorMsg,
      duration: 5
    });
    
    setGuardandoTemporada(false);
  }
};

  const handleEliminarTemporada = (temporada) => {
    Modal.confirm({
      title: '¿Eliminar temporada?',
      content: `Esta acción eliminará ${temporada.dias} días de precios del ${dayjs(temporada.fechaDesde).format('DD/MM/YYYY')} al ${dayjs(temporada.fechaHasta).format('DD/MM/YYYY')}`,
      okText: 'Sí, eliminar',
      cancelText: 'Cancelar',
      okButtonProps: { danger: true },
      onOk: () => handleEliminarTemporadaDirecta(temporada)
    });
  };

const handleEliminarTemporadaDirecta = async (temporada) => {
  try {
    const token = localStorage.getItem('token');
    
    // Mostrar mensaje de progreso
    const hideMessage = message.loading({
      content: `Eliminando ${temporada.dias} días...`,
      duration: 0,
      key: 'deletingTemporada'
    });
    
    // Crear un array de promesas para eliminar en paralelo
    const eliminaciones = temporada.lineas.map((linea) => 
      axios.delete(
        `${BASE_URL}/api/lineascontrato/${codigoContrato}/${linea.fecha}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );
    
    // Ejecutar eliminaciones en paralelo
    await Promise.all(eliminaciones);
    
    message.success({
      content: `Temporada eliminada: ${temporada.dias} días`,
      key: 'deletingTemporada',
      duration: 3
    });
    
    fetchLineas();
    
  } catch (error) {
    console.error('❌ Error eliminando temporada:', error);
    
    // Mostrar error
    const errorMsg = error.response?.data?.error || 'Error al eliminar la temporada';
    message.error({
      content: errorMsg,
      duration: 5
    });
  }
};

  const handleDuplicarTemporada = (temporada) => {
    setModalTemporadaType('create');
    setCurrentTemporada(null);
    
    // Cargar datos de la temporada a duplicar
    const precios = temporada.precios;
    setPreciosBase({
      preciopc: precios.preciopc || 0,
      preciomp: precios.preciomp || 0,
      preciohd: precios.preciohd || 0,
      precioha: precios.precioha || 0,
      PrecioIn: precios.PrecioIn || 0,
      preciodo: precios.preciodo || 0,
      precioti: precios.precioti || 0
    });
    
    setSuplementos({
      precioa1: precios.precioa1 || 0,
      precioa2: precios.precioa2 || 0,
      precioade: precios.precioade || 0,
      CheckPrecinInPorcentaje: precios.PrecioINPorcentaje || false
    });
    
    setDescuentos({
      preciode1: precios.preciode1 || 0,
      precioha1: precios.precioha1 || 0,
      precion11: precios.precion11 || 0,
      precion12: precios.precion12 || 0,
      preciode2: precios.preciode2 || 0,
      precioha2: precios.precioha2 || 0,
      precion21: precios.precion21 || 0,
      precion22: precios.precion22 || 0,
      preciode3: precios.preciode3 || 0,
      precioha3: precios.precioha3 || 0,
      precion31: precios.precion31 || 0,
      precion32: precios.precion32 || 0
    });
    
    setOtros({
      DobleUsoIndividual: precios.DobleUsoIndividual || 0,
      MinNoches: precios.MinNoches || 0,
      SuplCortEstanc: precios.SuplCortEstanc || 0,
      SuplCortEstancP: precios.SuplCortEstancP || 0,
      DUISuplemento: precios.DUISuplemento || false,
      DUIPorcentaje: precios.DUIPorcentaje || false,
      esweekend: precios.esweekend || false,
      PrecioINPorcentaje: precios.PrecioINPorcentaje || false
    });
    
    // Establecer rango de fechas para la duplicación
    const hoy = dayjs();
    formTemporada.setFieldsValue({
      fechaDesde: hoy,
      fechaHasta: hoy.add(temporada.dias - 1, 'day'),
      preciomp: precios.preciomp,
      preciohd: precios.preciohd,
      PrecioIn: precios.PrecioIn,
      esweekend: precios.esweekend,
      DobleUsoIndividual: precios.DobleUsoIndividual,
      MinNoches: precios.MinNoches,
      PrecioINPorcentaje: precios.PrecioINPorcentaje
    });
    
    setModalTemporadaVisible(true);
  };

  // ========== FUNCIONES PARA LÍNEAS INDIVIDUALES ==========

  const handleCreateLinea = () => {
    setModalLineaType('create');
    setCurrentLinea(null);
    formLinea.resetFields();
    
    // Valores por defecto
    formLinea.setFieldsValue({
      fecha: dayjs(),
      esweekend: false
    });
    
    setModalLineaVisible(true);
  };

  const handleEditLinea = (record) => {
    setModalLineaType('edit');
    setCurrentLinea(record);
    
    // Cargar datos en el formulario
    formLinea.setFieldsValue({
      fecha: dayjs(record.fecha),
      esweekend: record.esweekend || false
    });
    
    // Cargar datos en los estados
    setPreciosBase({
      preciopc: record.preciopc || 0,
      preciomp: record.preciomp || 0,
      preciohd: record.preciohd || 0,
      precioha: record.precioha || 0,
      PrecioIn: record.PrecioIn || 0,
      preciodo: record.preciodo || 0,
      precioti: record.precioti || 0
    });
    
    setSuplementos({
      precioa1: record.precioa1 || 0,
      precioa2: record.precioa2 || 0,
      precioade: record.precioade || 0,
      CheckPrecinInPorcentaje: record.PrecioINPorcentaje || false
    });
    
    setDescuentos({
      preciode1: record.preciode1 || 0,
      precioha1: record.precioha1 || 0,
      precion11: record.precion11 || 0,
      precion12: record.precion12 || 0,
      preciode2: record.preciode2 || 0,
      precioha2: record.precioha2 || 0,
      precion21: record.precion21 || 0,
      precion22: record.precion22 || 0,
      preciode3: record.preciode3 || 0,
      precioha3: record.PrecioHA3 || 0,
      precion31: record.precion31 || 0,
      precion32: record.precion32 || 0
    });
    
    setOtros({
      DobleUsoIndividual: record.DobleUsoIndividual || 0,
      MinNoches: record.MinNoches || 0,
      SuplCortEstanc: record.SuplCortEstanc || 0,
      SuplCortEstancP: record.SuplCortEstancP || 0,
      DUISuplemento: record.DUISuplemento || false,
      DUIPorcentaje: record.DUIPorcentaje || false,
      esweekend: record.esweekend || false,
      PrecioINPorcentaje: record.PrecioINPorcentaje || false
    });
    
    setModalLineaVisible(true);
  };

// pages/LineasContrato.js - handleSaveLinea actualizado
const handleSaveLinea = async () => {
  try {
    const values = await formLinea.validateFields();
    const token = localStorage.getItem('token');
    
    const fecha = values.fecha.format('YYYY-MM-DD');
    
    // Activar indicador de carga
    setGuardandoLinea(true);
    
    // Datos simplificados para el endpoint inteligente
    const datosLinea = {
      codigo: codigoContrato,
      fecha: fecha,
      preciomp: preciosBase.preciomp,
      preciohd: preciosBase.preciohd,
      PrecioIn: preciosBase.PrecioIn,
      esweekend: otros.esweekend,
      DobleUsoIndividual: otros.DobleUsoIndividual,
      MinNoches: otros.MinNoches,
    };
    
    // Mostrar mensaje de progreso
    const hideMessage = message.loading({
      content: modalLineaType === 'create' 
        ? 'Guardando línea...' 
        : 'Actualizando línea...',
      duration: 0,
      key: 'savingLinea'
    });
    
    try {
      // Usar el endpoint inteligente
      const response = await axios.post(`${BASE_URL}/api/lineascontrato/crear-linea`, datosLinea, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        message.success({
          content: response.data.action === 'created' 
            ? 'Línea creada correctamente' 
            : 'Línea actualizada correctamente',
          key: 'savingLinea',
          duration: 3
        });
        
        setModalLineaVisible(false);
        fetchLineas();
      }
      
    } finally {
      // Limpiar mensaje de carga
      hideMessage();
      setGuardandoLinea(false);
    }
    
  } catch (error) {
    console.error('❌ Error guardando línea:', error);
    
    // Mostrar error específico
    const errorMsg = error.response?.data?.error || 'Error al guardar la línea';
    message.error({
      content: errorMsg,
      duration: 5
    });
    
    setGuardandoLinea(false);
  }
}

  const handleDeleteLinea = async (fecha) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/api/lineascontrato/${codigoContrato}/${fecha}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      message.success('Línea eliminada correctamente');
      fetchLineas();
    } catch (error) {
      console.error('❌ Error eliminando línea:', error);
      message.error(error.response?.data?.error || 'Error al eliminar la línea');
    }
  };

  const handleDuplicateLinea = (record) => {
    // Preparar para crear una nueva línea con los mismos datos
    handleCreateLinea();
    
    // Cargar datos de la línea a duplicar
    setTimeout(() => {
      setPreciosBase({
        preciopc: record.preciopc || 0,
        preciomp: record.preciomp || 0,
        preciohd: record.preciohd || 0,
        precioha: record.precioha || 0,
        PrecioIn: record.PrecioIn || 0,
        preciodo: record.preciodo || 0,
        precioti: record.precioti || 0
      });
      
      setSuplementos({
        precioa1: record.precioa1 || 0,
        precioa2: record.precioa2 || 0,
        precioade: record.precioade || 0,
        CheckPrecinInPorcentaje: record.PrecioINPorcentaje || false
      });
      
      setDescuentos({
        preciode1: record.preciode1 || 0,
        precioha1: record.precioha1 || 0,
        precion11: record.precion11 || 0,
        precion12: record.precion12 || 0,
        preciode2: record.preciode2 || 0,
        precioha2: record.precioha2 || 0,
        precion21: record.precion21 || 0,
        precion22: record.precion22 || 0,
        preciode3: record.preciode3 || 0,
        precioha3: record.PrecioHA3 || 0,
        precion31: record.precion31 || 0,
        precion32: record.precion32 || 0
      });
      
      setOtros({
        DobleUsoIndividual: record.DobleUsoIndividual || 0,
        MinNoches: record.MinNoches || 0,
        SuplCortEstanc: record.SuplCortEstanc || 0,
        SuplCortEstancP: record.SuplCortEstancP || 0,
        DUISuplemento: record.DUISuplemento || false,
        DUIPorcentaje: record.DUIPorcentaje || false,
        esweekend: record.esweekend || false,
        PrecioINPorcentaje: record.PrecioINPorcentaje || false
      });
    }, 100);
  };

  // ========== RENDERIZADO DE COMPONENTES ==========

  // Componentes para el formulario de precios (compartido entre modales)
  const renderPreciosBase = () => (
    <Card size="small" title="Precios Base" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>MP:</Text>
            <InputNumber
              value={preciosBase.preciomp}
              onChange={(value) => setPreciosBase({...preciosBase, preciomp: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>HD:</Text>
            <InputNumber
              value={preciosBase.preciohd}
              onChange={(value) => setPreciosBase({...preciosBase, preciohd: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>IN:</Text>
            <InputNumber
              value={preciosBase.PrecioIn}
              onChange={(value) => setPreciosBase({...preciosBase, PrecioIn: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
        <Col span={6}>
          <Checkbox
            checked={suplementos.CheckPrecinInPorcentaje}
            onChange={(e) => setSuplementos({...suplementos, CheckPrecinInPorcentaje: e.target.checked})}
          >
            IN como %
          </Checkbox>
        </Col>
      </Row>
    </Card>
  );

  const renderDescuentosAdultos = () => (
    <Card size="small" title="Suplementos Adultos" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>1er Adulto (%):</Text>
            <InputNumber
              value={suplementos.precioa1}
              onChange={(value) => setSuplementos({...suplementos, precioa1: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="%"
            />
          </div>
        </Col>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>2º Adulto (%):</Text>
            <InputNumber
              value={suplementos.precioa2}
              onChange={(value) => setSuplementos({...suplementos, precioa2: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="%"
            />
          </div>
        </Col>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Adulto Especial:</Text>
            <InputNumber
              value={suplementos.precioade}
              onChange={(value) => setSuplementos({...suplementos, precioade: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
      </Row>
    </Card>
  );

  const renderNiños = () => (
    <Card size="small" title="Niños" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Niño 1:</Text>
            <InputNumber
              value={descuentos.precion11}
              onChange={(value) => setDescuentos({...descuentos, precion11: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Niño 2:</Text>
            <InputNumber
              value={descuentos.precion12}
              onChange={(value) => setDescuentos({...descuentos, precion12: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
        </Col>
      </Row>
    </Card>
  );

  const renderOtros = () => (
    <Card size="small" title="Otros" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Doble Uso Individual:</Text>
            <InputNumber
              value={otros.DobleUsoIndividual}
              onChange={(value) => setOtros({...otros, DobleUsoIndividual: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={0.01}
              precision={2}
              addonAfter="€"
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <Checkbox
              checked={otros.DUISuplemento}
              onChange={(e) => setOtros({...otros, DUISuplemento: e.target.checked})}
            >
              DUI es Suplemento
            </Checkbox>
          </div>
          <div style={{ marginBottom: 8 }}>
            <Checkbox
              checked={otros.DUIPorcentaje}
              onChange={(e) => setOtros({...otros, DUIPorcentaje: e.target.checked})}
            >
              DUI es Porcentaje
            </Checkbox>
          </div>
        </Col>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <Text strong>Mín. Noches:</Text>
            <InputNumber
              value={otros.MinNoches}
              onChange={(value) => setOtros({...otros, MinNoches: value || 0})}
              style={{ width: '100%', marginTop: 4 }}
              min={0}
              step={1}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <Checkbox
              checked={otros.esweekend}
              onChange={(e) => setOtros({...otros, esweekend: e.target.checked})}
            >
              Es Weekend
            </Checkbox>
          </div>
        </Col>
      </Row>
    </Card>
  );

  if (!contrato) {
    return (
      <PageContainer
        title="Cargando..."
        loading={true}
      />
    );
  }

  return (
    <>
      <PageContainer
        // title={`Líneas de Contrato: ${contrato.Codigo}`}
        title={`Líneas de Contrato`}
        // subtitle={contrato.Descripcion}
        icon={<FileTextOutlined />}
        extra={[
          <Button
            key="back"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/tarifas')}
          >
            Volver a Contratos
          </Button>,
          <Button
            key="nueva-temporada"
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCrearTemporada}
          >
            Nueva Temporada
          </Button>,
          <Button
            key="nueva-linea"
            type="default"
            icon={<PlusOutlined />}
            onClick={handleCreateLinea}
          >
            Nuevo Día
          </Button>
        ]}
      >
        {/* Información del contrato */}
        <Card size="small" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col span={6}>
              <Text strong>Código: </Text>
              <Tag color="blue">{contrato.Codigo}</Tag>
            </Col>
            <Col span={12}>
              <Text strong>Descripción: </Text>
              {contrato.Descripcion}
            </Col>
            <Col span={6}>
              <Text strong>Moneda: </Text>
              <Tag color="cyan">{contrato.Moneda}</Tag>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={6}>
              <Text strong>IVA: </Text>
              <Tag color="purple">{contrato.TipoIVA}</Tag>
            </Col>
            <Col span={6}>
              <Text strong>Estado: </Text>
              {contrato.Bloqueado ? (
                <Tag color="red">Bloqueado</Tag>
              ) : (
                <Tag color="green">Activo</Tag>
              )}
            </Col>
            <Col span={6}>
              <Text strong>Oferta: </Text>
              {contrato.EsOferta ? (
                <Tag color="orange">Sí</Tag>
              ) : (
                <Tag color="default">No</Tag>
              )}
            </Col>
          </Row>
        </Card>

        {/* Filtros */}
        <Card size="small" style={{ marginBottom: 16 }}>
          <Row gutter={16} align="middle">
            <Col>
              <DatePicker
                placeholder="Fecha desde"
                value={fechaDesde}
                onChange={setFechaDesde}
                format="DD/MM/YYYY"
              />
            </Col>
            <Col>
              <DatePicker
                placeholder="Fecha hasta"
                value={fechaHasta}
                onChange={setFechaHasta}
                format="DD/MM/YYYY"
              />
            </Col>
            <Col>
              <Checkbox
                checked={showWeekend}
                onChange={(e) => setShowWeekend(e.target.checked)}
              >
                Solo Weekend
              </Checkbox>
            </Col>
            <Col>
              <Button
                icon={<FilterOutlined />}
                onClick={() => {
                  aplicarFiltros();
                  aplicarFiltrosTemporadas();
                }}
              >
                Filtrar
              </Button>
            </Col>
            <Col>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFiltros}
              >
                Limpiar
              </Button>
            </Col>
            <Col flex="auto" style={{ textAlign: 'right' }}>
              <Text type="secondary">
                {activeTab === 'temporadas' 
                  ? `${temporadasFiltradas.length} temporadas, ${lineas.length} días totales`
                  : `${filtroLineas.length} de ${lineas.length} días`
                }
              </Text>
            </Col>
          </Row>
        </Card>

        {/* Tabs para Temporadas vs Días */}
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          style={{ marginBottom: 16 }}
        >
          <TabPane 
            tab={
              <span>
                <CalendarOutlined />
                Temporadas {temporadasFiltradas.length > 0 && `(${temporadasFiltradas.length})`}
              </span>
            } 
            key="temporadas"
          />
          <TabPane 
            tab={
              <span>
                <FileTextOutlined />
                Días Individuales {filtroLineas.length > 0 && `(${filtroLineas.length})`}
              </span>
            } 
            key="dias"
          />
        </Tabs>

        {/* Contenido según tab seleccionado */}
        {activeTab === 'temporadas' ? (
          <Table
            columns={columnsTemporadas}
            dataSource={temporadasFiltradas}
            rowKey="id"
            loading={loading}
            scroll={{ x: 1000 }}
            pagination={{
              pageSize: 20,
              showSizeChanger: true,
              showTotal: (total) => `Total: ${total} temporadas`
            }}
            expandable={{
              expandedRowRender: (record) => (
                <div style={{ margin: 0, padding: '16px', background: '#fafafa' }}>
                  <Text strong>Días incluidos en esta temporada:</Text>
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {record.lineas.map((linea, idx) => (
                      <Card size="small" key={idx} style={{ width: 200 }}>
                        <div>
                          <Text strong>{dayjs(linea.fecha).format('DD/MM/YYYY')}</Text>
                          <div>MP: {linea.preciomp.toFixed(2)}€</div>
                          <div>HD: {linea.preciohd.toFixed(2)}€</div>
                          {linea.esweekend && <Tag color="purple" size="small">WE</Tag>}
                        </div>
                      </Card>
                    ))}
                  </div>
                </div>
              ),
              rowExpandable: (record) => record.lineas.length > 0
            }}
          />
        ) : (
          <Table
            columns={columnsDias}
            dataSource={filtroLineas}
            rowKey="fecha"
            loading={loading}
            scroll={{ x: 1000, y: 500 }}
            pagination={{
              pageSize: 50,
              showSizeChanger: true,
              showTotal: (total) => `Total: ${total} días`
            }}
          />
        )}
      </PageContainer>

      {/* Modal para crear/editar temporada */}
    <Modal
        title={modalTemporadaType === 'create' ? 'Nueva Temporada' : 'Editar Temporada'}
        open={modalTemporadaVisible}
        onOk={handleGuardarTemporada}
        onCancel={() => {
            setModalTemporadaVisible(false);
            formTemporada.resetFields();
        }}
        width={800}
        okText={modalTemporadaType === 'create' ? 'Crear' : 'Guardar'}
        cancelText="Cancelar"
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        confirmLoading={guardandoTemporada}
        okButtonProps={{
            icon: guardandoTemporada ? <ReloadOutlined spin /> : <SaveOutlined />,
            disabled: guardandoTemporada
        }}
        >
        <Form
          form={formTemporada}
          layout="vertical"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="fechaDesde"
                label="Fecha Desde"
                rules={[{ required: true, message: 'Fecha desde requerida' }]}
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="fechaHasta"
                label="Fecha Hasta"
                rules={[{ required: true, message: 'Fecha hasta requerida' }]}
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
          </Row>

          {renderPreciosBase()}
          {renderDescuentosAdultos()}
          {renderNiños()}
          {renderOtros()}

          {modalTemporadaType === 'edit' && currentTemporada && (
            <Card size="small" title="Resumen de Cambios" style={{ marginTop: 16 }}>
              <Row gutter={16}>
                <Col span={12}>
                  <Text strong>Original:</Text>
                  <div>
                    {dayjs(currentTemporada.fechaDesde).format('DD/MM/YYYY')} - 
                    {dayjs(currentTemporada.fechaHasta).format('DD/MM/YYYY')}
                  </div>
                  <div><Tag color="blue">{currentTemporada.dias} días</Tag></div>
                </Col>
                <Col span={12}>
                  <Text strong>Nuevo:</Text>
                  <div>
                    {formTemporada.getFieldValue('fechaDesde')?.format('DD/MM/YYYY') || '-'} - 
                    {formTemporada.getFieldValue('fechaHasta')?.format('DD/MM/YYYY') || '-'}
                  </div>
                  <div>
                    <Tag color="green">
                      {(() => {
                        const desde = formTemporada.getFieldValue('fechaDesde');
                        const hasta = formTemporada.getFieldValue('fechaHasta');
                        if (desde && hasta) {
                          return `${hasta.diff(desde, 'day') + 1} días`;
                        }
                        return '? días';
                      })()}
                    </Tag>
                  </div>
                </Col>
              </Row>
            </Card>
          )}
        </Form>
      </Modal>

      {/* Modal para crear/editar línea individual */}
    <Modal
        title={modalLineaType === 'create' ? 'Nuevo Día de Precio' : 'Editar Día de Precio'}
        open={modalLineaVisible}
        onOk={handleSaveLinea}
        onCancel={() => {
            setModalLineaVisible(false);
            formLinea.resetFields();
        }}
        width={800}
        okText={modalLineaType === 'create' ? 'Crear' : 'Guardar'}
        cancelText="Cancelar"
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        confirmLoading={guardandoLinea}
        okButtonProps={{
            icon: guardandoLinea ? <ReloadOutlined spin /> : <SaveOutlined />,
            disabled: guardandoLinea
        }}
        >
        <Form
          form={formLinea}
          layout="vertical"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="fecha"
                label="Fecha"
                rules={[{ required: true, message: 'Fecha requerida' }]}
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="esweekend" label="Weekend" valuePropName="checked">
                <Checkbox>Es Weekend</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          {renderPreciosBase()}
          {renderDescuentosAdultos()}
          {renderNiños()}
          {renderOtros()}
        </Form>
      </Modal>
    </>
  );
};

export default LineasContrato;